import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishCreateObservationsPage } from '../../../dish/dish-create/dish-create-observations/dish-create-observations';
import { ProductCreateObservationsPage } from '../../../products/product-create/product-create-observations/product-create-observations';


/**
 * Generated class for the ArticleViewObservationsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view-observations',
    templateUrl: 'article-view-observations.html',
})
export class ArticleViewObservationsPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,) {
    }

    edit() {
        if (this.article.type === 'dish') {
            if (this.globals.checkLimitsByLicense('dishes', 'observations')) {
                this.navCtrl.push(DishCreateObservationsPage, {
                    update: true,
                    dish_uid: this.article.UID,
                    dish_name: this.globals.nameLangSelectDish(this.article),
                    observations: this.article.observations,
                    dish: this.article,
                });
            } else {
                this.navCtrl.push(AddonsTriggerVersionProPage);
            }
        } else {
            this.navCtrl.push(ProductCreateObservationsPage, {
                update: true,
                product_uid: this.article.UID,
                product_name: this.globals.nameLangSelectProduct(this.article),
                observations: this.article.observations,
                product: this.article,
            });
        }
    }


}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-observations/article-view-observations.ts